import React from 'react';
interface LogoProps {
  width?: number;
  height?: number;
  color?: string;
}
export function Logo({
  width = 40,
  height = 40,
  color = '#3B82F6'
}: LogoProps) {
  return <svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1000">
      <rect width="40" height="40" rx="8" fill={color} fillOpacity="0.1" data-id="element-1001" />
      <path d="M28 12H12C10.9 12 10 12.9 10 14V26C10 27.1 10.9 28 12 28H28C29.1 28 30 27.1 30 26V14C30 12.9 29.1 12 28 12Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1002" />
      <path d="M15 20H25" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1003" />
      <path d="M15 16H25" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1004" />
      <path d="M15 24H20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1005" />
    </svg>;
}